import { Outlet } from 'react-router-dom';

export default function Addresses() {
  return (
    <Outlet />
  )
}
